import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CounterDownComponent } from './counter-down.component';

@NgModule({
  declarations: [CounterDownComponent],
  exports: [CounterDownComponent],
  imports: [
    CommonModule
  ]
})
export class CounterDownModule { }
